// extracted by mini-css-extract-plugin
export default {"description":"style_description__hqUif","footer":"style_footer__zGsdr"};